// Rule values come from shared/passwordPolicy.json via the generated module; only the logic lives here.
import { PASSWORD_MIN_LENGTH, PASSWORD_REQUIRE_UPPERCASE } from './passwordPolicy.generated'

export { PASSWORD_MIN_LENGTH }

const requirements = PASSWORD_REQUIRE_UPPERCASE ? ' and contain at least one capital letter' : ''

export const PASSWORD_REQUIREMENTS_MESSAGE = `Your password must be at least ${PASSWORD_MIN_LENGTH} characters long${requirements}.`

export const PASSWORD_HINT = `At least ${PASSWORD_MIN_LENGTH} characters${PASSWORD_REQUIRE_UPPERCASE ? ', including one capital letter' : ''}.`

export const PASSWORD_MISMATCH_MESSAGE = 'Your passwords do not match'

export function getPasswordError(password: string): string | null {
	if (password.length < PASSWORD_MIN_LENGTH) return PASSWORD_REQUIREMENTS_MESSAGE
	if (PASSWORD_REQUIRE_UPPERCASE && !/[A-Z]/.test(password)) return PASSWORD_REQUIREMENTS_MESSAGE
	return null
}

// Returns the first problem with a new-password/confirm pair, or null when both are acceptable.
export function getNewPasswordError(password: string, confirmPassword: string): string | null {
	return getPasswordError(password) ?? (password !== confirmPassword ? PASSWORD_MISMATCH_MESSAGE : null)
}
